<template>
  <vis-inner-layout>
    <vis-loading size="md" v-if="loading" logo />
    <vis-error size="md" v-else-if="error" with-default logo :state="state" />
    <div
      v-else
      class="ba-relative ba-z-100 ba-w-full ba-max-w-sm sm:ba-w-auto sm:ba-max-w-none ba-max-h-full ba-m-auto ba-px-2 sm:ba-px-0 ba-py-10 md:ba-p-10 ba-text-base"
    >
      <footer class="ba-mx-4 permission__form-footer">
        <h4
          class="ba-text-xl ba-font-semibold ba-text-center ba-w-full ba-my-5 ba-select-none ba-text-white"
        >Выходим из личного кабинета</h4>
        <vis-loading size="md" />
      </footer>
    </div>
  </vis-inner-layout>
</template>

<script>
import VisInnerLayout from "./vis-inner-layout";
import { postLogoutMixin } from "@ba/visary-account-common-vue";

export default {
  name: "vis-page-post-logout",
  components: {
    VisInnerLayout
  },
  mixins: [postLogoutMixin]
};
</script>
